import { EvidenceItem } from "@/pages/ProductStructure/components/EvidenceCommentsDisplay";
import RedditCards, { RedditCardsSkeleton } from "../RedditCards";
import RedditLogo from "@/assets/icons/RedditLogo.svg";
import { CustomButton } from "@/components/ui/Buttons";
import { Dispatch, SetStateAction } from "react";

type RedditCommentsProps = {
  redditCommentsLoading: boolean;
  redditComments: any;
  handleOpenCommentsModal: (item: any) => void;
  showAllComments: boolean;
  setShowAllComments: Dispatch<SetStateAction<boolean>>;
};

const RedditComments = ({
  redditCommentsLoading,
  redditComments,
  handleOpenCommentsModal,
  showAllComments,
  setShowAllComments,
}: RedditCommentsProps) => {
  return (
    <section className="mt-8 sm:mt-10">
      <div className="flex items-center gap-x-2">
        <span className="flex-shrink-0">
          <RedditLogo />
        </span>
        <h3 className="text-black text-lg font-medium flex-1">
          Reddit Sourced Structures
        </h3>
      </div>
      <div className="mt-4 space-y-3">
        {redditCommentsLoading
          ? Array.from({ length: 3 }).map((_, index) => (
              <RedditCardsSkeleton key={`skeleton-${index}`} />
            ))
          : redditComments?.data
              ?.slice(0, showAllComments ? redditComments.data.length : 3)
              .map((item: EvidenceItem, index: number) => (
                <RedditCards
                  key={index}
                  item={item}
                  handleOpenCommentsModal={handleOpenCommentsModal}
                />
              ))}

        {redditComments?.meta?.isProcessing === false &&
          redditComments?.data?.length === 0 && (
            <p className="text-sm text-gray-500 text-center mt-4">
              No comments found.
            </p>
          )}
      </div>

      {redditComments.data && redditComments.data.length > 3 && (
        <div className="mx-auto mt-4 text-center max-w-xs">
          <CustomButton
            variant="outline"
            padding="8px 12px"
            color="#344054"
            fontWeight="medium"
            fontSize="12px"
            border="1px solid #E4E7EC"
            borderRadius="6px"
            className="w-full"
            onClick={() => setShowAllComments((prev) => !prev)}
          >
            {showAllComments ? "Show Less" : "View All"}
          </CustomButton>
        </div>
      )}
    </section>
  );
};

export default RedditComments;
